/* ==========================================================================
   E. Michael — Vault Campaign
   --------------------------------------------------------------------------
   Countdown, campaign FAQ, curated-set calculator and set add-to-cart.
   No third-party dependencies. Safe to remove with the vault-* sections.
   ========================================================================== */

(function () {
  'use strict';

  // The config snippet is rendered by every vault-* section, so this file can
  // be requested more than once on a page. Execute only the first time.
  if (window.__EMVaultLoaded) return;
  window.__EMVaultLoaded = true;

  var MONEY_FORMAT = (window.EMVault && window.EMVault.moneyFormat) || '${{amount}}';

  /* ---------------------------------------------------------------- money */

  function formatMoney(cents) {
    var value = Math.round(Number(cents) || 0);
    var format = MONEY_FORMAT;

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var name = placeholder ? placeholder[1] : 'amount';
    var out;

    switch (name) {
      case 'amount_no_decimals':
        out = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = withDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        out = withDelimiters(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = withDelimiters(value, 0, ' ', ',');
        break;
      default:
        out = withDelimiters(value, 2, ',', '.');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ------------------------------------------------------------ countdown */

  function initCountdown(root) {
    var iso = root.getAttribute('data-vault-open');
    if (!iso) return;

    var target = new Date(iso).getTime();
    if (isNaN(target)) {
      // An unparseable date must never render a fictional countdown.
      root.hidden = true;
      return;
    }

    var cells = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var remaining = target - Date.now();

      if (remaining <= 0) {
        // The countdown expires to zero and stays there. It never restarts.
        Object.keys(cells).forEach(function (k) {
          if (cells[k]) cells[k].textContent = '00';
        });
        root.setAttribute('data-vault-elapsed', 'true');
        var elapsedMsg = root.parentNode && root.parentNode.querySelector('[data-vault-elapsed-message]');
        if (elapsedMsg) elapsedMsg.hidden = false;
        clearInterval(timer);
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (cells.days) cells.days.textContent = pad(days);
      if (cells.hours) cells.hours.textContent = pad(hours);
      if (cells.minutes) cells.minutes.textContent = pad(minutes);
      if (cells.seconds) cells.seconds.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
    root.hidden = false;
  }

  /* ------------------------------------------------------------------ FAQ */

  function initFaq(root) {
    var buttons = root.querySelectorAll('.vault-faq__q');

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;

        var isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  /* ----------------------------------------------------------- curated set */

  function initSet(setEl) {
    var selects = setEl.querySelectorAll('[data-vault-variant]');
    if (!selects.length) return;

    var discount = parseFloat(setEl.getAttribute('data-vault-discount')) || 0;
    var isLive = setEl.getAttribute('data-vault-pricing') === 'live';

    var retailOut = setEl.querySelector('[data-vault-retail]');
    var priceOut = setEl.querySelector('[data-vault-setprice]');
    var saveOut = setEl.querySelector('[data-vault-saving]');
    var button = setEl.querySelector('[data-vault-addset]');
    var message = setEl.querySelector('[data-vault-setmsg]');

    function selected() {
      return Array.prototype.map.call(selects, function (select) {
        var option = select.options[select.selectedIndex];
        if (!option) return null;
        return {
          id: option.value,
          price: parseInt(option.getAttribute('data-price'), 10) || 0,
          available: option.getAttribute('data-available') === 'true'
        };
      });
    }

    function recalc() {
      var picks = selected();
      var retail = 0;
      var allAvailable = true;

      picks.forEach(function (pick) {
        if (!pick || !pick.id) { allAvailable = false; return; }
        retail += pick.price;
        if (!pick.available) allAvailable = false;
      });

      var setPrice = Math.round(retail * (1 - discount / 100));

      if (retailOut) retailOut.textContent = formatMoney(retail);
      if (priceOut) priceOut.textContent = formatMoney(setPrice);
      if (saveOut) saveOut.textContent = formatMoney(retail - setPrice);

      if (button) {
        button.setAttribute('aria-disabled', allAvailable ? 'false' : 'true');
        if (!allAvailable && message) {
          message.textContent = 'One of the selected sizes is unavailable. Choose another size to continue.';
        } else if (message && !message.getAttribute('data-locked')) {
          message.textContent = message.getAttribute('data-default') || '';
        }
      }
    }

    Array.prototype.forEach.call(selects, function (select) {
      select.addEventListener('change', recalc);
    });

    recalc();

    if (!button) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true') return;

      var picks = selected().filter(function (p) { return p && p.id; });
      if (!picks.length) return;

      var setName = setEl.getAttribute('data-vault-setname') || 'Set';
      var items = picks.map(function (pick) {
        return {
          id: Number(pick.id),
          quantity: 1,
          properties: { 'Set': setName }
        };
      });

      var original = button.textContent;
      button.textContent = 'Adding…';
      button.setAttribute('aria-disabled', 'true');

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart rejected the request');
          return response.json();
        })
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart');
        })
        .catch(function () {
          button.textContent = original;
          button.setAttribute('aria-disabled', 'false');
          if (message) {
            message.setAttribute('data-locked', 'true');
            message.textContent = 'That could not be added just now. Please try again.';
          }
        });
    });

    // Keep the unapproved-pricing state impossible to mistake for live pricing.
    if (!isLive && button) {
      button.setAttribute('data-vault-pricing-pending', 'true');
    }
  }

  /* --------------------------------------------------------------- reveal */

  function initReveal() {
    var items = document.querySelectorAll('.vault-rise');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    Array.prototype.forEach.call(items, function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------------ boot */

  function boot(scope) {
    var root = scope || document;

    Array.prototype.forEach.call(root.querySelectorAll('[data-vault-countdown]'), initCountdown);
    Array.prototype.forEach.call(root.querySelectorAll('[data-vault-faq]'), initFaq);
    Array.prototype.forEach.call(root.querySelectorAll('[data-vault-set]'), initSet);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-initialise when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
